export const HeaderTypes = {
  HOMEPAGE: 'homepage',
  SUBPAGE: 'subpage',
};
